module.exports = __webpack_public_path__ + "static/media/car_button_02.89ff51cc.png";